import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatLabel } from '@angular/material/form-field';
import { DeflectionCalcService } from '../services/deflection-calc.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'deflect-strong',
  standalone: true,
  
  templateUrl: './deflect-strong.component.html',
  styleUrl: './deflect-strong.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButtonModule
  ]
  
})
export class DeflectStrongComponent {

}
